import React from "react";
import { CTAButton, SectionLabel, Reveal, CountUp } from "../primitives";
import { Section, TCard, H2 } from "../shared";
import { investment } from "../content";
import { usePricing } from "@/lib/pricing";
import alinaImg from "@/assets/img/t-alina.png";

export default function InvestmentSection() {
  const { price, founding } = usePricing();
  return (
    <Section testId="investment-section" className="py-24 md:py-36">
      <SectionLabel testId="investment-label">Dein Investment</SectionLabel>
      <Reveal>
        <h2 className={`${H2} mb-14 max-w-3xl text-3xl md:text-5xl`}>Was ist Dein Investment?</h2>
      </Reveal>
      <div className="space-y-px">
        {investment.map((row, i) => (
          <Reveal key={row.t} delay={i * 0.05}>
            <div className="flex flex-col gap-2 border-t border-cognac/30 py-6 md:flex-row md:items-baseline md:justify-between md:gap-10">
              <p className="max-w-2xl font-heading text-lg font-600 uppercase tracking-tight text-espresso md:text-xl" style={{ fontWeight: 600 }}>
                {row.t}
              </p>
              <p className="shrink-0 font-heading text-lg font-700 uppercase text-cognac-2 md:text-xl" style={{ fontWeight: 700 }}>
                {row.w}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.1}>
        <div className="mt-10 border-t-2 border-espresso pt-8">
          <p className="font-heading text-xl font-700 uppercase tracking-tight text-espresso md:text-2xl" style={{ fontWeight: 700 }}>
            Gesamtwert: 8.999 €
          </p>
          <p className="mt-6 font-heading text-3xl font-700 uppercase tracking-tight text-cognac-2 md:text-5xl" style={{ fontWeight: 700 }}>
            Dein Investment:{" "}
            <CountUp key={price} to={price} testId="investment-countup" format={(v) => `${Math.round(v).toLocaleString("de-DE")} €`} />{founding && "*"}
          </p>
          <p className="mt-2 font-body text-lg italic text-espresso/80">(Ratenzahlung möglich)</p>
          {founding && (
            <p className="mt-6 max-w-3xl font-body text-base leading-[1.7] text-[#241a15]/80">
              *Gilt für alle Founding Members, die sich bis zum 10. Oktober 2026, 10:10 Uhr anmelden.
            </p>
          )}
          <div className="mt-10">
            <CTAButton variant="cognac" testId="investment-cta-button">Let's Play</CTAButton>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.14}>
        <div className="mt-16 max-w-2xl">
          <TCard
            img={alinaImg}
            name="Alina"
            lead="Ich habe mir endlich erlaubt, mich selbstständig zu machen."
            ps={[
              "Meine Rolle als globale Personalentwicklerin hatte sich ganz anders entwickelt als vorgestellt. Als ich auf das Coaching gestoßen bin, war ich einfach völlig unzufrieden, total kaputt und mir fehlte eine Perspektive, wo es für mich hingehen kann.",
              "Ich hatte 1.000 Ideen, was ich machen könnte. Gleichzeitig hatte ich viel Angst, meinen gut bezahlten Job aufzugeben.",
              "Während des Coachings habe ich ganz viel von mir wieder entdeckt, was ich total vergraben hatte. Ich weiß nun ganz klar, was mich ausmacht, was meine Werte sind und was ich brauche, um gut zu arbeiten.",
            ]}
            testId="testimonial-alina"
          />
        </div>
      </Reveal>
    </Section>
  );
}
